import { render } from "./pb-cards.vue?vue&type=template&id=288bce9a"
import script from "./pb-cards.vue?vue&type=script&lang=js"
export * from "./pb-cards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__